var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconHomeActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.7619 26H17.9524C17.2694 26 16.7143 25.4409 16.7143 24.7529V16.9585C16.7143 16.2705 16.1592 15.7114 15.4762 15.7114H10.5238C9.84079 15.7114 9.28571 16.2705 9.28571 16.9585V24.7529C9.28571 25.4409 8.73063 26 8.04762 26H1.2381C0.555079 26 0 25.4409 0 24.7529V8.01676C0 7.56988 0.237302 7.15626 0.623175 6.93386L12.3851 0.16417C12.7648 -0.0540724 13.2332 -0.0540724 13.6129 0.16417L25.3748 6.93386C25.7606 7.15626 25.9979 7.56988 25.9979 8.01676V24.7529C25.9979 25.4409 25.4429 26 24.7598 26H24.7619Z",
    fill: "#00C8D5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHomeActive);
export default __webpack_public_path__ + "static/media/IconHomeActive.61c0662da68140fa3022dd8aecda39ef.svg";
export { ForwardRef as ReactComponent };